module.exports = __webpack_public_path__ + "static/img/deec_logo.92204c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/partner-logos/deec_logo.png
// module id = K5ET
// module chunks = 0